<div class="navigator-logo-container">
  <div class="navigator-logo" [class.collapsed]="navigator.collapsed"></div>
  <button
    class="menu-collapse-button cursor-pointer"
    (click)="collapse()"
    [class.menu-collapse-button--hidden]="isSmallerScreen"
  >
    <span
      class="menu-collapse-icon"
      [class.icon-collapsed]="navigator.collapsed"
    ></span>
  </button>
</div>

<div class="navigator-container">
  <div class="navigator-main">
    <div class="navigator-side-top">
      <ng-container *nonVisitor>
        <div
          class="odd-shape-container"
          *ngIf="
            appState.hasRight([
              UserAction.ManageProducts,
              UserAction.ManageSupplierOffers,
              UserAction.ManageReceivedOffers,
              UserAction.ManageClients
            ])
          "
        >
          <span
            class="odd-shape-icon box-plus-icon"
            [class.active]="navigator.currentView === 1"
          ></span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="55"
            height="56"
            viewBox="0 0 55 56"
          >
            <a
              class="odd-shape-link"
              [class.active]="navigator.currentView === 1"
              (click)="toggleView()"
            >
              <defs>
                <linearGradient
                  id="odd-shape-gradient"
                  x1="-2.489%"
                  x2="31.863%"
                  y1="-55.313%"
                  y2="120.759%"
                >
                  <stop offset="0%" stop-color="#F04B54" />
                  <stop offset="100%" stop-color="#F7921E" />
                </linearGradient>
                <path id="a" d="M33.517 0L55 12.422V56H17.653L0 46V0h33.517z" />
              </defs>
              <use
                fill="#5E5357"
                fill-rule="evenodd"
                transform="matrix(-1 0 0 1 55 0)"
                xlink:href="#a"
              />
            </a>
          </svg>
        </div>
      </ng-container>
    </div>
    <nav class="navigator-links">
      <mat-tab-group
        class="navigator-tab-group no-tab-header"
        animationDuration="0"
        [(selectedIndex)]="navigator.currentView"
      >
        <mat-tab label="Main">
          <!-- DASHBOARD -->
          <a matRipple
            class="navigator-link"
            routerLink="/dashboard"
            [class.active]="isNavLinkActive('/dashboard')"
            [ngxTippy]="'navigator.links.dashboard' | translate"
            [tippyClassName]="collapsed ? null : 'hidden'"
            [tippyProps]="{
              placement: 'right'
            }"
          >
            <span class="navigator-link-icon dashboard-icon"></span>
            <span class="navigator-link-text">{{
              "navigator.links.dashboard" | translate
            }}</span>
          </a>

          <!-- NOTIFICATIONS -->
          <a matRipple
            class="navigator-link"
            routerLink="/notifications"
            [class.active]="isNavLinkActive('/notifications')"
            *nonVisitor
            [ngxTippy]="'navigator.links.notifications' | translate"
            [tippyClassName]="collapsed ? null : 'hidden'"
            [tippyProps]="{
              placement: 'right'
            }"
          >
            <span
              class="navigator-link-icon notifications-icon"
              [matBadge]="
                appState.inbox.notificationsBadgeCount >= 10
                  ? '9+'
                  : appState.inbox.notificationsBadgeCount
              "
              [matBadgeHidden]="
                !appState.inbox.notificationsBadgeCount ||
                appState.inbox.notificationsBadgeCount === 0
              "
              matBadgeSize="small"
              matBadgeColor="warn"
            ></span>
            <span class="navigator-link-text">{{
              "navigator.links.notifications" | translate
            }}</span>
          </a>

          <!-- PRODUCTS -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.Pim)">
            <a matRipple
              class="navigator-link"
              routerLink="/products"
              [class.active]="isNavLinkActive('/products')"
              *requiredRights="[UserAction.ViewProducts]"
              [ngxTippy]="'navigator.links.products' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon products-icon"></span>
              <span class="navigator-link-text">
                {{ "navigator.links.products" | translate }}
              </span>
              <svg-icon
                *ngIf="showProductReactiveLinks"
                key="arrowMenuSuperSmall"
                fontSize="11px"
                class="reactive-link-menu-arrow"
              ></svg-icon>

              <ng-container *standardPlan>
                <svg-icon
                  key="paidPlanOrangeSimple"
                  fontSize="16px"
                  *ngIf="!showProductReactiveLinks"
                ></svg-icon>
              </ng-container>
              <!-- <toggle-arrow [toggled]="true"></toggle-arrow> -->
            </a>
            <reactive-links
              *ngIf="showProductReactiveLinks"
              [options]="navigator.productReactiveLinkOptions"
            >
            </reactive-links>
          </ng-container>

          <!-- OFFERS -->
          <a matRipple
            class="navigator-link"
            routerLink="/offers"
            [class.active]="isNavLinkActive('/offers')"
            *ngIf="
              appState.hasRight([
                UserAction.ViewSupplierOffers,
                UserAction.ViewReceivedOffers
              ])
            "
            [ngxTippy]="'navigator.links.offers' | translate"
            [tippyClassName]="collapsed ? null : 'hidden'"
            [tippyProps]="{
              placement: 'right'
            }"
          >
            <span
              class="navigator-link-icon offers-icon"
              [matBadge]="
                appState.inbox.offersBadgeCount >= 10
                  ? '9+'
                  : appState.inbox.offersBadgeCount
              "
              [matBadgeHidden]="
                !appState.inbox.offersBadgeCount ||
                appState.inbox.offersBadgeCount === 0
              "
              matBadgeSize="small"
              matBadgeColor="warn"
            >
            </span>
            <span class="navigator-link-text">{{
              "navigator.links.offers" | translate
            }}</span>

            <!-- <ng-container *standardPlan>
              <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
            </ng-container> -->
          </a>

          <!-- CLIENTS -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.SellerCrm)">
            <a matRipple
              class="navigator-link"
              routerLink="/clients"
              [class.active]="isNavLinkActive('/clients')"
              *requiredRights="[
                UserAction.ViewClients,
                UserAction.ViewOthersClients
              ]"
              [ngxTippy]="'navigator.links.clients' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon clients-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.links.clients" | translate
              }}</span>
              <ng-container *standardPlan>
                <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
              </ng-container>
            </a>
          </ng-container>

          <!-- SUPPLIERS -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.BuyerCrm)">
            <a matRipple
              class="navigator-link"
              routerLink="/suppliers"
              [class.active]="isNavLinkActive('/suppliers')"
              *requiredRights="[UserAction.ViewSuppliers]"
              [ngxTippy]="'navigator.links.suppliers' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon clients-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.links.suppliers" | translate
              }}</span>
              <ng-container *standardPlan>
                <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
              </ng-container>
            </a>
          </ng-container>

          <!-- CALENDAR -->
          <ng-container
            *ngIf="
              appState.hasModule(LxmAppModule.ViewMarketCalendar) ||
              appState.hasModule(LxmAppModule.ManageCalendar)
            "
          >
            <a matRipple
              class="navigator-link"
              routerLink="/calendar"
              [class.active]="isNavLinkActive('/calendar')"
              *ngIf="
                appState.hasRight([
                  UserAction.ManageOfferCalendar,
                  UserAction.ViewPublishedOffersCalendar
                ])
              "
              [ngxTippy]="'navigator.links.calendar' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon calendar-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.links.calendar" | translate
              }}</span>
              <ng-container *standardPlan>
                <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
              </ng-container>
            </a>
          </ng-container>

          <!-- PURCHASE MANAGER DESKTOP -->
          <ng-container
            *ngIf="
              appState.hasModule(LxmAppModule.PurchaseManagerDesktop) &&
              appState.hasRight([UserAction.ManageReceivedOffers])
            "
          >
            <a matRipple
              class="navigator-link"
              routerLink="/workspace"
              [class.active]="isNavLinkActive('/workspace')"
              [ngxTippy]="
                'navigator.links.purchase_manager_workspace' | translate
              "
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span
                class="navigator-link-icon purchase-manager-workspace-icon"
              ></span>
              <span class="navigator-link-text">
                {{ "navigator.links.purchase_manager_workspace" | translate }}
              </span>

              <ng-container *standardPlan>
                <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
              </ng-container>
            </a>
          </ng-container>

          <!-- MARKET -->
          <ng-container
            *ngIf="
              appState.hasModule(LxmAppModule.ViewMarket) &&
              appState.hasRight([UserAction.ViewMarket])
            "
          >
            <a matRipple
              class="navigator-link"
              routerLink="/market"
              [class.active]="isNavLinkActive('/market')"
              [ngxTippy]="'navigator.links.products_retailer' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon products-global-icon"></span>
              <span class="navigator-link-text">
                {{ "navigator.links.market" | translate }}
              </span>
              <ng-container *standardPlan>
                <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
              </ng-container>
            </a>
            <reactive-links
              *ngIf="showMarketReactiveLinks"
              [options]="navigator.productReactiveLinkOptions"
            >
            </reactive-links>
          </ng-container>

          <!-- E-STORE -->
          <ng-container
            *ngIf="appState.hasModule(LxmAppModule.BuyerStore)"
          >
            <a matRipple
              class="navigator-link"
              routerLink="/store"
              [class.active]="isNavLinkActive('/store')"
              *requiredRights="[UserAction.ViewStore]"
              [ngxTippy]="'navigator.links.store' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span
                class="navigator-link-icon store-icon"
                [matBadge]="
                  appState.inbox.storeBadgeCount >= 10
                    ? '9+'
                    : appState.inbox.storeBadgeCount
                "
                [matBadgeHidden]="
                  !appState.inbox.storeBadgeCount ||
                  appState.inbox.storeBadgeCount === 0
                "
                matBadgeSize="small"
                matBadgeColor="warn"
              ></span>
              <span class="navigator-link-text">{{
                "navigator.links.store" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- ORDERS -->
          <ng-container
            *requiredModules="['CreatePurchaseOrders', 'CreateSalesOrders']"
          >
            <a matRipple
              class="navigator-link"
              routerLink="/orders"
              [class.active]="isNavLinkActive('/orders')"
              *requiredRights="[
                UserAction.ViewPurchaseOrders,
                UserAction.ViewSalesOrders
              ]"
              [ngxTippy]="'navigator.links.orders' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span
                class="navigator-link-icon orders-icon"
                [matBadge]="
                  appState.inbox.ordersBadgeCount >= 10
                    ? '9+'
                    : appState.inbox.ordersBadgeCount
                "
                [matBadgeHidden]="
                  !appState.inbox.ordersBadgeCount ||
                  appState.inbox.ordersBadgeCount === 0
                "
                matBadgeSize="small"
                matBadgeColor="warn"
              ></span>
              <span class="navigator-link-text">{{
                "navigator.links.orders" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- LOCATIONS -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.Locations)">
            <a matRipple
              class="navigator-link"
              routerLink="/locations"
              [class.active]="isNavLinkActive('/locations')"
              *requiredRights="[UserAction.ViewLocations]"
              [ngxTippy]="'navigator.links.location' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon location-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.links.location" | translate
              }}</span>
              <ng-container *standardPlan>
                <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
              </ng-container>
            </a>
          </ng-container>

          <!-- ALTERATIONS -->
          <ng-container
            *ngIf="appState.hasModule(LxmAppModule.SendProductUpdates)"
          >
            <a matRipple
              class="navigator-link"
              routerLink="/alterations"
              [class.active]="isNavLinkActive('/alterations')"
              *requiredRights="[UserAction.ViewProductUpdates]"
              [ngxTippy]="'navigator.links.alterations' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon alterations-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.links.alterations" | translate
              }}</span>
              <ng-container *standardPlan>
                <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
              </ng-container>
            </a>
          </ng-container>

          <!-- IMPORT -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.Pim)">
            <a matRipple
              class="navigator-link"
              routerLink="/import"
              [class.active]="isNavLinkActive('/import')"
              *requiredRights="[UserAction.ImportProducts]"
              [ngxTippy]="'navigator.links.imports' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon imports-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.links.imports" | translate
              }}</span>
              <ng-container *standardPlan>
                <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
              </ng-container>
            </a>
          </ng-container>

          <!-- REPORTS -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.Reports)">
            <a matRipple
              class="navigator-link"
              routerLink="/reports"
              [class.active]="isNavLinkActive('/reports')"
              *requiredRights="[UserAction.ViewReports, UserAction.ViewOthersReports]"
              [ngxTippy]="'navigator.links.reports' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon reports-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.links.reports" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- SETTINGS -->
          <a matRipple
            class="navigator-link"
            routerLink="/settings"
            [class.active]="isNavLinkActive('/settings')"
            *ngIf="appState.hasRight([UserAction.ViewClvs])"
            [ngxTippy]="'navigator.links.settings' | translate"
            [tippyClassName]="collapsed ? null : 'hidden'"
            [tippyProps]="{
              placement: 'right'
            }"
          >
            <span class="navigator-link-icon settings-icon"></span>
            <span class="navigator-link-text">{{
              "navigator.links.settings" | translate
            }}</span>
          </a>
        </mat-tab>

        <mat-tab label="Secondary">
          <!-- ADD PRODUCT -->
          <a matRipple
            class="navigator-link"
            (click)="navigateQuickAction('/products/new')"
            routerLink="/products/new"
            *requiredRights="[UserAction.ManageProducts]"
            [ngxTippy]="'navigator.quick_links.add_product' | translate"
            [tippyClassName]="collapsed ? null : 'hidden'"
            [tippyProps]="{
              placement: 'right'
            }"
          >
            <span class="navigator-link-icon products-icon"></span>
            <span class="navigator-link-text">{{
              "navigator.quick_links.add_product" | translate
            }}</span>
            <ng-container *standardPlan>
              <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
            </ng-container>
          </a>

          <!-- REQUEST OFFER -->
          <a matRipple
            class="navigator-link"
            (click)="navigateQuickAction('/offers/request')"
            routerLink="/offers/request"
            *requiredRights="[UserAction.ReceiveOffers]"
            [ngxTippy]="'navigator.quick_links.request_offer' | translate"
            [tippyClassName]="collapsed ? null : 'hidden'"
            [tippyProps]="{
              placement: 'right'
            }"
          >
            <span class="navigator-link-icon offers-icon"></span>
            <span class="navigator-link-text">{{
              "navigator.quick_links.request_offer" | translate
            }}</span>
            <ng-container *standardPlan>
              <svg-icon key="paidPlanOrangeSimple" fontSize="16px"></svg-icon>
            </ng-container>
          </a>

          <!-- PURCHASE ORDERS -->
          <ng-container
            *ngIf="appState.hasModule(LxmAppModule.CreatePurchaseOrders)"
          >
            <a matRipple
              class="navigator-link"
              (click)="navigateQuickAction('/orders/purchase/new')"
              routerLink="/orders/purchase/new"
              *requiredRights="[UserAction.ManageOfferCalendar]"
              [ngxTippy]="
                'navigator.quick_links.create_purchase_order' | translate
              "
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon orders-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.quick_links.create_purchase_order" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- SALES ORDERS -->
          <ng-container
            *ngIf="appState.hasModule(LxmAppModule.CreateSalesOrders)"
          >
            <a matRipple
              class="navigator-link"
              (click)="navigateQuickAction('/orders/sales/new')"
              routerLink="/orders/sales/new"
              *requiredRights="[UserAction.ManageOfferCalendar]"
              [ngxTippy]="
                'navigator.quick_links.create_sales_order' | translate
              "
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon orders-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.quick_links.create_sales_order" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- NEW OFFER -->
          <a matRipple
            class="navigator-link"
            (click)="navigateQuickAction('/offers/new')"
            routerLink="/offers/new"
            *requiredRights="[UserAction.ManageSupplierOffers]"
            [ngxTippy]="'navigator.quick_links.new_offer' | translate"
            [tippyClassName]="collapsed ? null : 'hidden'"
            [tippyProps]="{
              placement: 'right'
            }"
          >
            <span class="navigator-link-icon offers-icon"></span>
            <span class="navigator-link-text">{{
              "navigator.quick_links.new_offer" | translate
            }}</span>
          </a>

          <!-- NEW CALENDAR ENTRY - still needs to open dialog -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.ManageCalendar)">
            <a matRipple
              class="navigator-link"
              (click)="navigateQuickAction('/calendar', ['newCalendarEntry'])"
              routerLink="/calendar"
              *requiredRights="[UserAction.ManageOfferCalendar]"
              [ngxTippy]="
                'navigator.quick_links.new_calendar_entry' | translate
              "
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon calendar-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.quick_links.new_calendar_entry" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- ADD CLIENT -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.SellerCrm)">
            <a matRipple
              class="navigator-link"
              (click)="navigateQuickAction('/clients/new')"
              routerLink="/clients/new"
              [queryParams]="{ action: 'addUser' }"
              *requiredRights="[UserAction.ManageClients]"
              [ngxTippy]="'navigator.quick_links.add_client' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon clients-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.quick_links.add_client" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- ADD SUPPLIER -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.BuyerCrm)">
            <a matRipple
              class="navigator-link"
              (click)="navigateQuickAction('/suppliers/new')"
              routerLink="/suppliers/new"
              *requiredRights="[UserAction.ManageSuppliers]"
              [ngxTippy]="'navigator.quick_links.add_supplier' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon clients-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.quick_links.add_supplier" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- ADD LOCATION -->
          <ng-container *ngIf="appState.hasModule(LxmAppModule.Locations)">
            <a matRipple
              class="navigator-link"
              (click)="navigateQuickAction('/locations/new')"
              routerLink="/locations/new"
              *requiredRights="[UserAction.ManageLocations]"
              [ngxTippy]="'navigator.quick_links.add_location' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon location-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.quick_links.add_location" | translate
              }}</span>
            </a>
          </ng-container>

          <!-- ADD USER -->
          <ng-container *requiredRights="[UserAction.ManageUsers]">
            <a matRipple
              class="navigator-link"
              (click)="navigateQuickAction('/lxm-settings/users', ['addUser'])"
              routerLink="/lxm-settings/users"
              [ngxTippy]="'navigator.quick_links.add_user' | translate"
              [tippyClassName]="collapsed ? null : 'hidden'"
              [tippyProps]="{
                placement: 'right'
              }"
            >
              <span class="navigator-link-icon settings-icon"></span>
              <span class="navigator-link-text">{{
                "navigator.quick_links.add_user" | translate
              }}</span>
            </a>
          </ng-container>
        </mat-tab>
      </mat-tab-group>
    </nav>
  </div>

  <div class="navigator-side-bottom">
    <!-- ? MENU -->
    <ng-container *nonVisitor>
      <div class="odd-shape-container">
        <span class="odd-shape-icon box-question-icon"></span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="55"
          height="64"
          viewBox="0 0 55 64"
        >
          <a
            class="odd-shape-link"
            [class.active]="infoTrigger.menuOpen"
            #infoTrigger="matMenuTrigger"
            [matMenuTriggerFor]="infoMenu"
          >
            <defs>
              <linearGradient
                id="odd-shape-gradient"
                x1="-2.489%"
                x2="31.863%"
                y1="-55.313%"
                y2="120.759%"
              >
                <stop offset="0%" stop-color="#F04B54" />
                <stop offset="100%" stop-color="#F7921E" />
              </linearGradient>
            </defs>
            <path
              fill="#5E5357"
              fill-rule="evenodd"
              d="M17.653 0L0 10v53.577L16.95 54H55V0z"
            />
          </a>
        </svg>
      </div>
      <mat-menu #infoMenu="matMenu" class="navigator-menu navigator-info-menu">
        <ng-container *requiredRights="[UserAction.ReceiveProcurements]">
          <a
            *ngIf="supplierFrVgInstructionsLink"
            class="navigator-menu-button"
            mat-menu-item
            href="{{ supplierFrVgInstructionsLink }}"
            target="_blank"
            >{{ "navigator.info_menu.supplier_frvg" | translate }}</a
          >
        </ng-container>
        <ng-container *requiredRights="[UserAction.ViewProducts]">
          <a
            *ngIf="packagingDataInstructionsLink"
            class="navigator-menu-button"
            mat-menu-item
            href="{{ packagingDataInstructionsLink }}"
            target="_blank"
            >{{
              "navigator.info_menu.packaging_data_instructions" | translate
            }}</a
          >
        </ng-container>
        <ng-container *requiredRights="[UserAction.ManagePurchaseOrders]">
          <a
            *ngIf="ordersInstructionsLink"
            class="navigator-menu-button"
            mat-menu-item
            href="{{ ordersInstructionsLink }}"
            target="_blank"
            >{{ "navigator.info_menu.orders_instructions" | translate }}</a
          >
        </ng-container>
        <ng-container *nonVisitor>
          <a
            *ngIf="userManagementLink"
            class="navigator-menu-button"
            mat-menu-item
            href="{{ userManagementLink }}"
            target="_blank"
          >
            {{ "navigator.info_menu.user_management" | translate }}
          </a>
        </ng-container>
        <ng-container *requiredRights="[UserAction.ManageProcurements]">
          <a
            *ngIf="pujuLink"
            class="navigator-menu-button"
            mat-menu-item
            href="{{ pujuLink }}"
            target="_blank"
          >
            {{ "navigator.info_menu.frvg" | translate }}
          </a>
        </ng-container>
        <ng-container *requiredModules="['SellerStore']">
          <a mat-menu-item *ngIf="sellerStoreManualLink" class="navigator-menu-button" href="{{ sellerStoreManualLink }}" target="_blank">
            {{ "navigator.info_menu.seller_store_manual" | translate }}
          </a>
        </ng-container>
        <ng-container *requiredModules="['BuyerStore']">
          <a mat-menu-item *ngIf="buyerStoreManualLink" class="navigator-menu-button" href="{{ buyerStoreManualLink }}" target="_blank">
            {{ "navigator.info_menu.buyer_store_manual" | translate }}
          </a>
        </ng-container>
        <a
          class="navigator-menu-button"
          mat-menu-item
          href="{{ contactLink }}"
          target="_blank"
          >{{ "navigator.info_menu.contact" | translate }}</a
        >
        <span class="app-version"
          >{{ "global.version" | translate }}: {{ version }}</span
        >
      </mat-menu>
    </ng-container>

    <!-- USER MENU -->
    <div class="odd-shape-container">
      <span class="odd-shape-icon box-profile-icon"></span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="55"
        height="56"
        viewBox="0 0 55 56"
      >
        <a
          class="odd-shape-link"
          [class.active]="userTrigger.menuOpen"
          #userTrigger="matMenuTrigger"
          [matMenuTriggerFor]="userMenu"
        >
          <defs>
            <linearGradient
              id="odd-shape-gradient"
              x1="-2.489%"
              x2="31.863%"
              y1="-55.313%"
              y2="120.759%"
            >
              <stop offset="0%" stop-color="#F04B54" />
              <stop offset="100%" stop-color="#F7921E" />
            </linearGradient>
          </defs>
          <path
            fill="#5E5357"
            fill-rule="evenodd"
            d="M17.653 0L0 10v46h33.518L55 43.578V0z"
          />
        </a>
      </svg>
    </div>
    <mat-menu
      #userMenu="matMenu"
      class="navigator-menu navigator-user-menu"
      focusOnOpen="false"
    >
      <div class="navigator-menu-tenants" [ngSwitch]="showTenantsFilter">
        <ng-container *ngSwitchCase="true" [formGroup]="form">
          <lxm-select
            style="padding: 8px"
            for="tenant"
            [options]="tenants"
            [searchable]="true"
            value="id"
            [clearable]="false"
            (change)="switchTenant($event.id)"
            stop-propagation
          >
          </lxm-select>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <a
            *ngFor="let tenant of tenants"
            mat-menu-item
            class="navigator-menu-button"
            [class.current]="tenant.id === tenantId"
            (click)="switchTenant(tenant.id)"
            tabIndex="-1"
          >
            {{ tenant.name }}
          </a>
        </ng-container>
      </div>

      <span class="navigator-menu-header">
        {{ appState.user?.name || appState.user?.email }}
      </span>
      <div
        class="navigator-menu-button navigator-menu-select-button"
        mat-menu-item
        (click)="$event.stopPropagation()"
      >
        <mat-select
          class="navigator-menu-select"
          [compareWith]="languageValueCompare"
          [(ngModel)]="locale.currentLanguage"
          (selectionChange)="changeLanguage($event.value)"
          panelClass="navigator-menu-select-backdrop"
        >
          <mat-select-trigger>
            <div class="align-center flex flex-row" style="line-height: 1em">
              <svg-icon
                [key]="getLanguageIcon(locale.currentLanguage.id)"
                fontSize="16px"
                class="mr10"
                matPrefix
              ></svg-icon>
              {{ locale.currentLanguage.name }}
            </div>
          </mat-select-trigger>
          <mat-option
            class="navigator-menu-select-option"
            *ngFor="let lang of languageOptions"
            [value]="lang"
          >
            <div class="align-center flex flex-row" style="line-height: 1em">
              <svg-icon
                [key]="getLanguageIcon(lang.id)"
                fontSize="16px"
                class="mr10"
                matPrefix
              ></svg-icon>
              {{ lang.name }}
            </div>
          </mat-option>
        </mat-select>
      </div>

      <a matRipple
        class="navigator-menu-button"
        mat-menu-item
        routerLink="/user-settings"
        [class.active]="isNavLinkActive('/user-settings')"
        *nonVisitor
      >
        {{ "navigator.user_menu.user_settings" | translate }}
      </a>

      <ng-container
        *ngIf="
          appState.hasRight([UserAction.ManageSettings, UserAction.ViewUsers])
        "
      >
        <a matRipple
          class="navigator-menu-button"
          mat-menu-item
          [routerLink]="adminLinkUrl"
          [class.active]="isNavLinkActive(adminLinkUrl)"
        >
          {{ "navigator.user_menu.lexi_market_settings" | translate }}
        </a>
      </ng-container>
      <a class="navigator-menu-button" mat-menu-item (click)="logout()">
        {{ "navigator.user_menu.log_out" | translate }}
      </a>
    </mat-menu>
  </div>
</div>

<ng-container *standardPlan>
  <div
    class="mb-[30px] ml-[70px] flex h-[105px] flex-col items-center justify-center gap-5x border-t border-grey-30 py-8x"
    *ngIf="!collapsed"
  >
    <p class="w-full text-center font-text text-grey-100">
      Kasutad paketti piiratud funktsionaalsusega
    </p>
    <lxm-button
      label="Muuda pakketi"
      type="beige"
      class="w-max"
      routerLink="/lxm-settings/subscription"
    ></lxm-button>
  </div>
</ng-container>
